import { Component, ViewChild } from '@angular/core'; import { TotpService } from 'src/app/services/totp.service';
import { AuthService } from 'src/app/services/auth.service'; import { Capacitor } from '@capacitor/core'; import { MenuItem } from 'primeng/api';
import { ErrorHandlerService } from 'src/app/services/error-handler.service'; import { Menu } from 'primeng/menu';
import { ActivatedRoute, Router } from '@angular/router'; import { finalize } from 'rxjs/operators'; import { SanctumService } from 'src/app/services/sanctum.service';
import { StoreService } from 'src/app/services/store.service'; import { Share } from '@capacitor/share';
@Component({
  selector: 'app-login-creators',
  templateUrl: './login-creators.component.html',
  styleUrls: ['./login-creators.component.scss']
})
export class LoginCreatorsComponent {

  phone = '';
  otp = '';
  otpSent = false;
  isLoading = false;
  errorMsg = '';

  constructor(
    private authService: AuthService,
    private errorHandler: ErrorHandlerService,
    private totpService: TotpService,
    private route: ActivatedRoute,
    private router: Router,
    private storeService: StoreService, private sanctum: SanctumService
  ) {
    console.log('[Capacitor] referenced in LoginCreatorsComponent');
    }

  storeParam: string | null = null;

  storeProfileImg?: string;
  primary_color?: string;
  secondary_color?: string;
  store_description?: string;
  store_name?: string;
  link_player?: string;
  link_store?: string;
  wallpaper?: string;
  loadingStore = true;
  isSharing = false;
  @ViewChild('menu') menu!: Menu;

  menuItems: MenuItem[] = [
    {
      label: 'Compartilhar',
      icon: 'pi pi-share-alt',
      command: () => this.compartilhar()
    }
  ];

  async compartilhar() {
    try {
      this.isSharing = true;

      // URL completa atual, inclusive parâmetros (?store=163, etc.)
      const shareUrl = window.location.href;

      if (Capacitor.isNativePlatform()) {
        await Share.share({
          title: 'Compartilhar Link',
          text: 'Veja esse conteúdo!',
          url: shareUrl,
          dialogTitle: 'Compartilhar via'
        });
      } else if (navigator.share) {
        await navigator.share({
          title: document.title || 'Compartilhar Link',
          url: shareUrl
        });
      } else {
        // fallback: copia pro clipboard
        await navigator.clipboard.writeText(shareUrl);
        // aqui você pode acionar um toast próprio
        console.log('Link copiado para a área de transferência.');
      }
    } catch (err) {
      console.error('Erro ao compartilhar:', err);
    } finally {
      this.isSharing = false;
      this.menu?.hide(); // fecha o popup caso ainda esteja aberto
    }
  }

  async ngOnInit(): Promise<void> {
    // Tenta em rota (/:store) e, se não houver, tenta em query (?store=)
    const byPath = this.route.snapshot.paramMap.get('store');
    const byQuery = this.route.snapshot.queryParamMap.get('store');

    this.storeParam = (byPath ?? byQuery)?.trim() || null;

    if (!this.storeParam) {
      this.router.navigateByUrl('/notfound');
      return;
    } else {
      await this.sanctum.initSanctum('creator');
      this.storeService.detailStoreInfosPublicById(this.storeParam).pipe(finalize(() => this.loadingStore = false)).subscribe(
        (response: any) => {
          if (response.creators_screen == '0') {
            this.router.navigateByUrl('/notfound');
          }

          console.log('store')
          console.log(response)
          this.storeProfileImg = response.favicon;
          this.primary_color = response.primary_color;
          this.secondary_color = response.secondary_color;
          this.store_name = response.store_name;
          this.store_description = response.store_description;
          this.link_store = 'https://'+response.url_store;
          this.wallpaper = response.store_wallpaper || 'assets/teste.png'; //response.wallpaper;

          const subdomain = response.store_link_subdomain;
          if (subdomain && typeof subdomain === 'string') {
            // remove tudo depois do primeiro ponto
            const firstPart = subdomain.split('.')[0];
            this.link_player = `https://slicksell.link/${firstPart}`;
          } else {
            this.link_player = '';
          }


        },
        (error: any) => {

        }
      );
    }


  }

  // Troca entre signup/signin   mode: 'signin' | 'signup' = 'signin';
  modeOptions = [
    { label: 'Entrar',      value: 'signin' },
    { label: 'Criar conta', value: 'signup' },
  ];
  mode: 'signin' | 'signup' = 'signin';

  setMode(next: 'signin' | 'signup') {
    this.mode = next;
    this.otpSent = false;
    this.otp = '';
    this.errorMsg = '';
    if (next === 'signup') this.phoneExists = null;
  }
  
  toggleMode() {
    this.setMode(this.mode === 'signin' ? 'signup' : 'signin');
  }
  

  ////////////////////////
  phoneExists: boolean | null = null;
  name: string = '';
  nameTouched = false;

  async onPhoneBlur() {
    this.phoneTouched = true;
    if (!this.isPhoneValid()) {
      this.phoneExists = null;
      return;
    }
    try {
      const res = await this.authService.verifyPhone(this.phone);
      this.phoneExists = res.exists;
      // Se não existe, usuário deve preencher nome
    } catch (e) {
      this.phoneExists = null;
    }
  }

  ////////////////////////

  async sendOTP() {
    this.isLoading = true;
    this.errorMsg = '';
    try {
      const resp = await this.authService.sendOtpWhatsApp(this.phone);
      console.log(resp);
      if (resp.exists) {
        this.errorMsg = 'Telefone já cadastrado.';
      }
      this.otpSent = true;
      this.isLoading = false;
      this.startCooldown(60); 
    } catch (err: any) {
      // Aqui pega o erro, pode pegar a mensagem do backend
      this.errorHandler.handle(err, 'Erro ao verificar telefone. Tente novamente.');
      this.errorMsg = 'Erro ao verificar telefone. Tente novamente.';
      this.isLoading = false;
    }
  }


  async submitOTP() {
    this.isLoading = true;
    this.errorMsg = '';
    try {
      // Aqui envia o telefone validado pro backend
      const body: any = { phone: this.phone, otp: this.otp };
      if (!this.phoneExists && this.name) {
        body.name = this.name;
      }
      const res = await this.authService.loginWithPhone(body);
      // Tratar token/jwt/cookie, redirecionar, etc.
      // Exemplo para JWT mobile:
      if (res.access_token) {
        localStorage.setItem("access_token_creators", res.access_token);
      }
      const isMobileApp = Capacitor.isNativePlatform();
      const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
      if (isMobileApp || isLocalhost) {
        if (res.totp_secret) {
          await this.totpService.saveJwtTokens('creator', res.access_token, res.totp_secret);
        }
        
      }

      // Para SPA, apenas navegar
      this.router.navigate(['/invite/163']);
      this.isLoading = false;
    } catch (err) {
      this.errorHandler.handle(err, 'Erro ao autenticar/criar usuário. Tente novamente.');
      this.errorMsg = 'Erro ao autenticar/criar usuário. Tente novamente.';
      this.errorMsg = 'Código inválido!';
      this.isLoading = false;
    }
  }



  phoneTouched = false;
  isPhoneValid(): boolean {
    // Remove todos os caracteres que não são dígito
    const digits = this.phone ? this.phone.replace(/\D/g, '') : '';
    // Para celular: DDD + 9 dígitos (ex: 11999999999) => 11 dígitos
    return digits.length === 11;
  }

  onOtpInputChange(otp: string) {
    this.otp = otp;
  }

  cooldown = 0;           // segundos restantes
  private cooldownInterval?: any;

  private startCooldown(seconds = 60) {
    this.cooldown = seconds;
    clearInterval(this.cooldownInterval);
    this.cooldownInterval = setInterval(() => {
      this.cooldown--;
      if (this.cooldown <= 0) {
        clearInterval(this.cooldownInterval);
      }
    }, 1000);
  }

  resendLabel(): string {
    return this.cooldown > 0 ? `Reenviar código (${this.cooldown}s)` : 'Reenviar código';
  }

  onClickResend() {
    if (this.cooldown > 0 || this.isLoading) return;
    // Reenvia e reinicia o timer
    this.sendOTP(); // passando um flag opcional só para semântica
  }

  ngOnDestroy() {
    clearInterval(this.cooldownInterval);
  }


}

